<template>
  <div class="d-none d-lg-block">
    <div class="px-3 pb-2 mb-2 font-weight-bold">
      <i class="fa fa-calendar mr-1"></i>
      Calendars
    </div>
  </div>
</template>

<style scoped>
.router-link-active {
  font-weight: bold;
}
</style>

<script>

export default {
  //
}
</script>